import React, { useEffect, useState } from "react";
import styles from "./Analytics.module.scss";
import { Controller, useForm } from "react-hook-form";
import ExpandLessSharpIcon from "@mui/icons-material/ExpandLessSharp";
import ExpandMoreSharpIcon from "@mui/icons-material/ExpandMoreSharp";
import RomLineChart from "../../components/Common/LineChart/RomLineChart";
import HumanBody from "../../assets/Images/HumanBody.svg";
import Moderate from "../../assets/Images/bodyPartMarkerModerate.svg";
import BodyPartMarker from "../../assets/Images/bodyPartMarker.svg";
import {
  getPainTrackingData,
  getProgressiveDataForUser,
} from "../../services/DashboardServices";
import { useParams } from "react-router-dom";
import dropdown from "../../assets/Icons/dropdown.svg";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const Analytics = () => {
  const { control, setValue, watch } = useForm({
    defaultValues: {
      exerciseType: "rom",
    },
  });
  const { userId } = useParams();
  const [selectedBodyPart, setSelectedBodyPart] = useState("");
  // function to watch the exercise type
  const watchExerciseType = watch("exerciseType");
  const [chartData, setChartData] = useState([]);
  const [chartData1, setChartData1] = useState([]);
  const [painTrackingData, setPainTrackingData] = useState([]);
  const [progressiveData, setProgressiveData] = useState([]);
  const [selectedExercise, setSelectedExercise] = useState(null);
  const [listOfBodyParts, setListOfBodyParts] = useState([]);

  useEffect(() => {
    getProgressiveDataForUser(userId).then((res) => {
      setProgressiveData(res.data.exercise_result_history);
      setSelectedExercise(
        res.data.exercise_result_history[0].body_part_exercise_result_details[0]
          .exercise_sub_category_result_details[0].exercise_sub_category
      );
      if (
        res.data.exercise_result_history[0].body_part_exercise_result_details[0]
          .exercise_sub_category_result_details[0].exercise_sub_category
      ) {
        setSelectedBodyPart(
          res.data.exercise_result_history[0]
            .body_part_exercise_result_details[0]
            .exercise_sub_category_result_details[0].exercise_sub_category
        );
        setProgressiveData(res.data.exercise_result_history);
      }
      setChartData(
        res.data.exercise_result_history[0].body_part_exercise_result_details[0]
          .exercise_sub_category_result_details[0].exercise_result_history
      );
      setValue(
        "exerciseType",
        res.data.exercise_result_history[0].exercise_category
      );
    });
    getPainTrackingData(userId).then((res) => {
      const data = [
        {
          name: "Pain",
          values: res.data.pain_feedback_history,
          color: res.data.color_code,
        },
      ];
      setPainTrackingData(data);
    });
  }, []);

  const setActiveBodyPart = (bodyPart) =>
    setSelectedBodyPart((prev) => (prev === bodyPart ? "" : bodyPart));

  useEffect(() => {
    if (progressiveData) {
      const filteredData = progressiveData.filter(
        (item) => item.exercise_category === watchExerciseType
      );
      setListOfBodyParts(filteredData);
      setActiveBodyPart(
        filteredData[0]?.body_part_exercise_result_details[0].body_part_name
      );
    }
  }, [ progressiveData, watchExerciseType ]);

  useEffect(() => {
    const data =
      chartData &&
      chartData.map((item) => {
        return {
          name: item.exercise_name,
          values: item.exercise_analytics,
          //if the exercise name contains left then color is orange else purple
          color: item.color_code,
        };
      });
    setChartData1(data);
  }, [chartData]);

  const bodyPartsListRenderer = () => {
    return (
      <>
        {listOfBodyParts[0]?.body_part_exercise_result_details?.map(
          (item, index) => {
            return (
              <ul key={index}>
                {
                  <>
                    {selectedBodyPart === item.body_part_name ? (
                      <li
                        className={styles.bodyPart}
                        style={{
                          width: "100%",
                        }}
                        onClick={() => setActiveBodyPart(item.body_part_name)}
                        id={item.body_part_name}
                      >
                        {item.body_part_name} &nbsp;
                        {selectedBodyPart === item.body_part_name ? (
                          <ExpandLessSharpIcon />
                        ) : (
                          <ExpandMoreSharpIcon />
                        )}
                      </li>
                    ) : (
                      <li
                        className={styles.bodyPart}
                        style={{
                          width: "100%",
                          backgroundColor: "white",
                        }}
                        onClick={() => setActiveBodyPart(item.body_part_name)}
                        id={item.body_part_name}
                      >
                        {item.body_part_name} &nbsp;
                        {selectedBodyPart === item.body_part_name ? (
                          <ExpandLessSharpIcon />
                        ) : (
                          <ExpandMoreSharpIcon />
                        )}
                      </li>
                    )}
                  </>
                }
                {selectedBodyPart === item.body_part_name && (
                  <ul>
                    {item.exercise_sub_category_result_details.map(
                      (exercise, index) => {
                        return (
                          <li
                            key={index}
                            className={styles.exercise}
                            onClick={() => {
                              setSelectedExercise(
                                exercise.exercise_sub_category
                              );
                              setChartData(exercise.exercise_result_history);
                            }}
                          >
                            {exercise.exercise_sub_category ===
                            selectedExercise ? (
                              <span className="text-[#415280] font-medium cursor-pointer">
                                {exercise.exercise_sub_category}
                              </span>
                            ) : (
                              <span className="text-[#3F3D56] font-normal opacity-50 cursor-pointer">
                                {exercise.exercise_sub_category}
                              </span>
                            )}
                          </li>
                        );
                      }
                    )}
                  </ul>
                )}
              </ul>
            );
          }
        )}
      </>
    );
  };

  const scrollToContent = (content) => {
    if(listOfBodyParts[0]?.body_part_exercise_result_details.filter( ele => ele.body_part_name === content ).length > 0 && content !== selectedBodyPart ){
      const contentDiv = document.getElementById(content);
      if (contentDiv) {
        setActiveBodyPart(
          content
        );
        window.scrollTo({
          top: contentDiv.offsetTop,
          behavior: 'smooth',
        });
      }
    }
  }

  return (
    <div className={styles.analyticsContainer}>
      <div className={styles.bodyPartAnalyticsSection}>
        <div className="mb-3">
          <Controller
            name="exerciseType"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <select
                {...field}
                style={{
                  backgroundImage: `url(${dropdown})`,
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "right 10px center",
                  backgroundSize: "20px",
                  paddingRight: "30px",
                }}
                className="
              appearance-none"
              >
                <option value="rom">Rom exercises </option>
                <option value="rep"> Functional Exercise</option>
                <option value="hold">Balance Exercise</option>
              </select>
            )}
          />
        </div>
        <div className="flex items-center">
          <div className={styles.leftSection}>
            <div className="flex gap-10 items-center">
              <div className="w-1/2 pl-4">
                <div className={styles.header}>
                  Body parts{" "}
                  <InfoOutlinedIcon
                    sx={{
                      width: "16px",
                      height: "16px",
                    }}
                  />
                </div>
                <div className={styles.bodyPartList}>{ bodyPartsListRenderer() }</div>
              </div>
              <div className="flex justify-center">
              <div
                className="relative"
                style={{
                  marginBottom: "16px",
                  marginTop: "28px",
                }}
              >
                <img width={100} height={240} src={HumanBody} className="
                  max-w-none" alt="" />
                <img
                  src={BodyPartMarker}
                  id="neck"
                  className="absolute w-[10px] top-[30px] left-[45px] cursor-pointer"
                  alt="leftNeckImgRef"
                  onClick={() => scrollToContent("Neck")}
                />
                 <img
                  src={BodyPartMarker}
                  id="neck"
                  className="absolute w-[10px] top-[30px] left-[45px] cursor-pointer"
                  alt="rightNeckImgRef"
                  onClick={() => scrollToContent("Neck")}
                />
                <img
                  src={BodyPartMarker}
                  className="absolute w-[10px] left-[18px] top-[40px] cursor-pointer"
                  alt="leftShoulderImgRef"
                  onClick={() => scrollToContent("Shoulder")}
                />
                <img
                  src={BodyPartMarker}
                  className="absolute w-[10px] top-[40px] left-[72px] cursor-pointer"
                  alt="rightShoulderImgRef"
                  onClick={() => scrollToContent("Shoulder")}
                />
                <img
                  src={BodyPartMarker}
                  className="absolute w-[10px] left-[29px] top-[100px] cursor-pointer"
                  alt="leftBackImgRef"
                  onClick={() => scrollToContent("Back")}
                />
                <img
                  src={BodyPartMarker}
                  className="absolute w-[10px] left-[60px] top-[100px] cursor-pointer"
                  alt="rightBackImgRef"
                  onClick={() => scrollToContent("Back")}
                />
                <img
                  src={BodyPartMarker}
                  className="absolute w-[10px] top-[172px] left-[30px] cursor-pointer"
                  alt="leftLowerLimbImgRef"
                  onClick={() => scrollToContent("Lower Limb")}
                />
                <img
                  src={BodyPartMarker}
                  className="absolute w-[10px] top-[172px] left-[60px] cursor-pointer"
                  alt="rightLowerLimbImgRef"
                  onClick={() => scrollToContent("Lower Limb")}
                />
                <img
                  src={BodyPartMarker}
                  className="absolute w-[10px] top-[225px] left-[29px] cursor-pointer"
                  alt="leftHoldImgRef"
                  title="hello"
                  onClick={() => scrollToContent("Hold")}
                />
                <img
                  src={BodyPartMarker}
                  className="absolute w-[10px] top-[225px] left-[60px] cursor-pointer"
                  alt="rightHoldImgRef"
                  onClick={() => scrollToContent("Hold")}
                />
              </div>
            </div>
            </div>
          </div>
          {chartData1.length > 0 && (
            <div className="w-full h-full">
              <div
                className="flex items-center justify-between pb-4"
                style={{
                  borderBottom: "1px solid #DDD",
                }}
              >
                <div className="flex items-center">
                  <div className="text-xs text-[#415280]">
                    X-axis : <span className="font-medium">Months</span>
                  </div>
                  &nbsp;
                  <div className="text-xs text-[#415280]">
                    Y-axis :{" "}
                    <span className="font-medium">Measure Angle Outcome</span>
                  </div>
                </div>
                <div className="flex items-center gap-3 justify-end pr-[72px]">
                  <div className="flex items-center gap-2">
                    <div
                      style={{
                        width: "24px",
                        height: "8px",
                        borderRadius: "100px",
                        background: " #FFA621",
                      }}
                    ></div>
                    <div
                      style={{
                        color: "var(--dark-2, #415280)",
                        fontFamily: "Poppins",
                        fontSize: "10px",
                        fontStyle: "normal",
                        fontWeight: 400,
                        lineHeight: "normal",
                      }}
                    >
                      Left body
                    </div>
                  </div>
                  <div className="flex items-center gap-2">
                    <div
                      style={{
                        width: "24px",
                        height: "8px",
                        borderRadius: "100px",
                        background: "#EB77F5",
                      }}
                    ></div>
                    <div
                      style={{
                        color: "var(--dark-2, #415280)",
                        fontFamily: "Poppins",
                        fontSize: "10px",
                        fontStyle: "normal",
                        fontWeight: 400,
                        lineHeight: "normal",
                      }}
                    >
                      Right body
                    </div>
                  </div>
                </div>
              </div>
              {chartData1.length > 0 && (
                <RomLineChart
                  yAxisTickFormat={
                    watchExerciseType === "rom"
                      ? "°"
                      : watchExerciseType === "rep"
                      ? "%"
                      : "sec"
                  }
                  key={chartData1[0].name}
                  data={chartData1}
                />
              )}
            </div>
          )}
        </div>
      </div>
      <div className={styles.painTrackingAnalyticsSection}>
        <div className={styles.header}>Pain Tracking</div>
        <div
          className="flex items-center justify-between pb-4 pt-8"
          style={{
            borderBottom: "1px solid #DDD",
          }}
        >
          <div className="flex items-center">
            <div className="text-xs text-[#415280]">
              X-axis : <span className="font-medium">Months</span>
            </div>
            &nbsp;
            <div className="text-xs text-[#415280]">
              Y-axis : <span className="font-medium">Pain Scale</span>
            </div>
          </div>
        </div>
        <div>
          {painTrackingData && painTrackingData.length > 0 && (
            <RomLineChart yAxisTickFormat="" data={painTrackingData} />
          )}
        </div>
      </div>
    </div>
  );
};

export default Analytics;
